import { IconPlayerStop } from '@tabler/icons-react';
import { Button, Flex } from '@mantine/core';
import Delta from 'quill-delta';
import { useEffect, useRef } from 'react';
import CollaborativeEditor from '../CollaborativeEditor';
import GenerateContent from './GenerateContent';

const AiDocumentEditor = ({
  generatedContentId,
  content,
  aiModel,
  provider,
  quillEditorRef,
  isLoading,
  setIsLoading,
  isLocked,
  abortStream,
  abortButtonVisible,
  setShowAbortButton,
  userError,
  setUserError,
  controllerRef,
  handleBrandContextChange,
}) => {
  const generateContentRef = useRef();
  const hideGenerateContent = async () => {
    await generateContentRef.current.hideGenerateContent();
  };

  useEffect(() => {
    const delta = new Delta(content.delta);
    quillEditorRef.current.getEditor().updateContents(delta, 'silent');
  }, [content, quillEditorRef]);

  const containerClasses = ['quill-main-container'];

  if (isLoading) {
    containerClasses.push('quill-main-container--loading');
    document.querySelector('.App')?.click();
  }

  // Unfocus the editor so we can not type with the keyboard when locked
  if (isLocked) {
    containerClasses.push('quill-main-container--locked');
    document?.querySelector('.App')?.click();
  }

  return (
    <>
      <GenerateContent
        quillEditorRef={quillEditorRef}
        setIsLoading={setIsLoading}
        generateContentRef={generateContentRef}
        aiModel={aiModel}
        provider={provider}
        userError={userError}
        setUserError={setUserError}
        controllerRef={controllerRef}
        setShowAbortButton={setShowAbortButton}
        handleBrandContextChange={handleBrandContextChange}
      />

      <div className={containerClasses.join(' ')} onClick={hideGenerateContent}>
        <CollaborativeEditor
          generatedContentId={generatedContentId}
          quillEditorRef={quillEditorRef}
          aiModel={aiModel}
          provider={provider}
          controllerRef={controllerRef}
          setShowAbortButton={setShowAbortButton}
        />
      </div>

      {abortButtonVisible && (
        <Flex direction="row" justify="center" align="center" className="stream-abort-button-position">
          <Button style={{ width: '20%' }} variant="primary" onClick={abortStream}>
            <IconPlayerStop size={14} /> Stop generating
          </Button>
        </Flex>
      )}
    </>
  );
};

export default AiDocumentEditor;
